import type React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@iconify/react';
import { Chip } from '@heroui/react';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';

type GroupMarkerProps = {
    rowNumber: number;
    sku: string;
    /** How many rows share the SKU (more than one). */
    groupSize: number;
};

/**
 * The SKU group marker beside a row's SKU, in the table and on the phone
 * cards: a soft chip with a link icon and how many rows share the SKU
 * ("Rows sharing SKU IP15: 3" for screen readers).
 */
export const GroupMarker: React.FC<GroupMarkerProps> = ({
    rowNumber,
    sku,
    groupSize,
}) => {
    const { t } = useTranslation('pages');

    return (
        <Chip
            size="sm"
            variant="soft"
            {...getNodeTestIdProp(`catalog-import-row-group-${rowNumber}`)}
        >
            <Icon aria-hidden className="size-3" icon="gravity-ui:link" />
            <Chip.Label>
                <span aria-hidden>{groupSize}</span>
                <span className="sr-only">
                    {t('catalogImport.products.group', {
                        rows: groupSize,
                        sku,
                    })}
                </span>
            </Chip.Label>
        </Chip>
    );
};
